import setFilters from 'store/reducer-utils/setFilters'
import { currencyMap } from 'utils/formatMoney'
import prepareChartData from 'utils/prepareChartData'
import { updateObject } from 'utils/updateObject'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import {
  PULSE_ANALYTICS_CAMPAIGNS_FETCH_FAIL,
  PULSE_ANALYTICS_CAMPAIGNS_FETCH_START,
  PULSE_REMOVE_METRIC,
  PULSE_SET_ANALYTICS_CAMPAIGNS,
  PULSE_SET_CHART_TYPE,
  PULSE_SET_FILTER,
  PULSE_SET_METRIC_DISABLED,
  PULSE_SET_NEW_METRIC,
  PULSE_SET_NEW_METRICS,
  PULSE_SETUP_INITIAL_METRICS,
  PULSE_TOGGLE_METRIC_HIDDEN,
  PULSE_TOGGLE_METRIC_STATUS_ACTIVE,
} from 'modules/Statistics/types'

const initialState = {
  filters: null,
  analytics: {
    loading: false,
    loaded: false,
    data: [],
  },
  measure: {
    conversion_rate: '%',
    avg_click_price: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    cost: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    profit: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    revenue: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    'common_metrics.drr': '%',
    'common_metrics.roi': '%',
    'google_analytics_metrics.transaction_revenue': IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    ctr: '%',
    'google_analytics_metrics.drr': '%',
    'google_analytics_metrics.roi': '%',
    'google_analytics_metrics.bounce_rate': '%',
  },
  metrics: [],
  chartType: 'Line',
}

const applyMetrics = (state, { payload }) =>
  updateObject(state, {
    metrics: payload.metrics,
  })

const setPulseFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setAnalyticsCampaigns = (state, action) => {
  const data = action.payload.data
  const { items, summary } = data

  const preparedChartData = prepareChartData(items, summary)

  return {
    ...state,
    analytics: {
      ...state.analytics,
      data: { ...data, ...preparedChartData },
      loaded: true,
      loading: false,
    },
  }
}

const analyticsCampaignsFetchStart = (state) => {
  return {
    ...state,
    analytics: {
      ...state.analytics,
      loading: true,
    },
  }
}

const analyticsCampaignsFetchFail = (state) => {
  return {
    ...state,
    analytics: {
      ...state.analytics,
      loading: false,
    },
  }
}

const setNewMetric = (state, action) => {
  return {
    ...state,
    metrics: [
      ...state.metrics,
      { id: action.payload.metric, isActive: action.payload.isActive || false },
    ],
  }
}

const setNewMetrics = (state, action) => {
  const metrics = action.payload.metrics.map((metric) => ({
    id: metric,
    isActive: false,
  }))
  return {
    ...state,
    metrics: [...state.metrics, ...metrics],
  }
}

const removeMetric = (state, action) => {
  return {
    ...state,
    metrics: [...state.metrics.filter(({ id }) => id !== action.payload.id)],
  }
}

const toggleMetricActive = (state, action) => {
  return {
    ...state,
    metrics: [
      ...state.metrics.map((metric) => {
        const { id, isActive } = metric
        if (id === action.payload.id) {
          return { id, isActive: !isActive }
        }
        return metric
      }),
    ],
  }
}

const toggleMetricHidden = (state, action) => {
  return {
    ...state,
    metrics: [
      ...state.metrics.map((metric) => {
        const { id, isHidden = false } = metric
        if (id === action.payload.id) {
          return { ...metric, isHidden: !isHidden }
        }
        return metric
      }),
    ],
  }
}

const setMetricDisabled = (state, action) => {
  return {
    ...state,
    metrics: [
      ...state.metrics.map((metric) => {
        const { id } = metric
        if (action.payload.ids.includes(id)) {
          return { ...metric, disabled: true }
        }
        return { ...metric, disabled: false }
      }),
    ],
  }
}

const setChartType = (state, action) => {
  return {
    ...state,
    chartType: action.payload.type,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PULSE_SETUP_INITIAL_METRICS:
      return applyMetrics(state, action)
    case PULSE_SET_FILTER:
      return setPulseFilters(state, action)
    case PULSE_SET_ANALYTICS_CAMPAIGNS:
      return setAnalyticsCampaigns(state, action)
    case PULSE_ANALYTICS_CAMPAIGNS_FETCH_START:
      return analyticsCampaignsFetchStart(state)
    case PULSE_ANALYTICS_CAMPAIGNS_FETCH_FAIL:
      return analyticsCampaignsFetchFail(state)
    case PULSE_SET_NEW_METRIC:
      return setNewMetric(state, action)
    case PULSE_SET_NEW_METRICS:
      return setNewMetrics(state, action)
    case PULSE_TOGGLE_METRIC_STATUS_ACTIVE:
      return toggleMetricActive(state, action)
    case PULSE_TOGGLE_METRIC_HIDDEN:
      return toggleMetricHidden(state, action)
    case PULSE_SET_METRIC_DISABLED:
      return setMetricDisabled(state, action)
    case PULSE_REMOVE_METRIC:
      return removeMetric(state, action)
    case PULSE_SET_CHART_TYPE:
      return setChartType(state, action)

    default:
      return state
  }
}

export default reducer
